// extracted by mini-css-extract-plugin
module.exports = {"section":"PaymentBankSection__section--1_30I","displayNone":"PaymentBankSection__displayNone--3mVcq"};